module.exports = __webpack_public_path__ + "img/sw.7a770d5a.png";